<template>
  <div class="form-comment">
    <el-dialog v-model="dialog" @close="handleClose" :close-on-click-modal="false">
      <div id="waiting" class="center" v-if="loading"></div>
      <div class="popup-header">
        <p class="title">
          {{ $t('contacts.comment.form_comment.title') }}
        </p>
      </div>
      <div class="last-message" v-if="lastMessage">
        <div class="child">
          <p id="idLineContact" ref="idLineContact" class="whitespace-pre-line" :class="showAll ? '' : 'not-show-all'" v-html="lastMessage"></p>
          <span v-if="showLine>3" class="btn-show" @click="handleShowLastMessage">
            {{ showAll ? '▲' + $t('contacts.not_show_all') : '▼' + $t('contacts.show_all') }}
          </span>
        </div>
      </div>
      <div class="main">
        <div class="child">
          <el-form :rules="rules" :model="form" ref="form" id="form">
            <el-form-item prop="message">
              <el-input
                type="textarea"
                :placeholder="$t('contacts.comment.form_comment.placholer')"
                v-model="form.message"
              >
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" @click="confirm" class="btn btn-confirm">{{ $t('contacts.comment.form_comment.btn_confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      openFormComment: { type: Boolean, required: true, default: false },
      urls: { type: Object, required: true, default: {} },
      lastMessage: { type: String, required: true, default: '' },
      newMessage: { type: String, required: true, default: '' }
    },
    emits: ['isClosePopupComment', 'confirmNewMessage'],
    data() {
      const checkEmpty = (rule, value, callback) => {
        if (!value || value.trim().length === 0) {
          callback(new Error('error'));
        } else {
          callback();
        }
      }
      return {
        dialog: '',
        loading: false,
        showAll: false,
        showLine: 0,
        form: {
          message: ''
        },
        rules: {
          message: [
            { validator: checkEmpty, message: this.$t('errors.required', [this.$t('contacts.comment.text')]), trigger: 'blur' },
          ],
        }
      }
    },
    methods: {
      handleClose() {
        this.$emit('isClosePopupComment');
      },

      confirm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.isOpenPopupConfirmComment = true;
            this.$emit('confirmNewMessage', this.form.message);
          } else {
            return false;
          }
        });
      },

      handleShowLastMessage() {
        this.showAll = !this.showAll;
      },

      closePopupConfirmComment() {
        this.isOpenPopupConfirmComment = false;
      }
    },
    created() {
      this.dialog = this.openFormComment;
      this.form.message = this.newMessage;
    },
    mounted(){
      this.$nextTick(()=>{
        this.showLine = Math.floor((this.$refs.idLineContact.scrollHeight)/28);
      });
    }
  }
</script>

<style lang="scss">
  .form-comment {
    .el-dialog {
      --el-dialog-width: 760px;
      --el-dialog-margin-top: 10vh;
      .el-dialog__body {
        height: 610px;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 0;
          background: transparent;
        }
      }
    }
    text-align: center !important;
    .title {
      font: normal normal normal 17px/37px Kozuka Gothic Pr6N;
      letter-spacing: 1.7px;
      color: #000000;
      font-weight: 700
    }
    .last-message {
      padding: 0 48px;
      .child {
        width: 100%;
        margin: 0 auto;
        text-align: left;
        border-left: solid 1px #DDD8D1;
        padding-left: 15px;
        .not-show-all {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0;
        }
        p {
          font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          line-height: 28px;
          margin: 0;
          color: #000;
        }
        .btn-show {
          color: #17609F;
          cursor: pointer;
          padding-top: 6px;
          display: inline-block;
        }
      }
    }
    .main {
      padding: 0 48px;
      .child {
        width: 100%;
        margin: 25px auto;
        .el-form {
          width: 100%;
          .el-form-item__content {
            margin-top: 0;
          }
        }
        .el-textarea {
          --el-input-border-radius: 0;
          --el-input-border-color: #DDD8D1;
          --el-input-focus-border-color: #DDD8D1;
          .el-textarea__inner {
            padding: 20px;
            color: #000;
            height: 220px;
            line-height: 29px;
            letter-spacing: 1.3px;
          }
        }
      }
    }
    .footer {
      margin-top: 35px;
      .btn {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #FFFFFF;
        width: 250px;
        height: 50px;
        border-radius: 25px !important;
        margin-left: 25px;
        &:first-child {
          margin-left: 0;
        }
      }
      .btn-confirm {
        background: #AC3B29 0% 0% no-repeat padding-box;
        --el-button-hover-bg-color: #AC3B29;
        --el-button-hover-border-color: #AC3B29;
        --el-button-border-color: #AC3B29;
      }
    }
  }
</style>
